<script setup lang="ts">
useSeo({
  title: `Home - Discover Podcasts & Radio Stations`,
  description: `Zeno.FM is the fastest and easiest way to discover and listen to podcasts and streaming radio stations. We specialize in international content from countries like Brazil, Mexico, Colombia, Haiti, Argentina, Ghana, Peru, Guatemala, Spain, and many more!`,
})
</script>

<template>
  <div class="md:space-y-12 space-y-6">
    <PageTitle>Home</PageTitle>

    <SearchInput />

    <StationsLocal />

    <StationsTop />

    <PodcastsTop />
  </div>
</template>

<style scoped></style>
